import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import {
  USER_ACCESS_COOKIE,
  PRIVACY_POLICY,
  PLATFORM_RESPONSIBILITY_TERM
} from '@plataforma/utils';
import { TermsAPI } from '@services/api';
import Cookies from 'js-cookie';
import * as S from './TermsStyles';
import { Check } from './Components/Check';

export const Terms = ({ toggleModal, fetchedTerms, setModalStatus }) => {
  const { t } = useTranslation();
  const [qtdAcceptedTerms, setQtdTerms] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const getVersion = termName => {
    const resultTerm =
      fetchedTerms && fetchedTerms.find(term => term.description === termName);

    return resultTerm ? resultTerm.version : 0;
  };

  let filtredItems = [];

  const ALL_TERMS = [
    {
      description: PLATFORM_RESPONSIBILITY_TERM,
      label: (
        <S.Text>
          {t('modal.statementResponsibility.labelTerms.1')}
          {t('modal.statementResponsibility.labelTerms.1_1')}
          <a
            href={TermsAPI.getTermDocument(
              'termo-de-responsabilidade-plataforma',
              getVersion(PLATFORM_RESPONSIBILITY_TERM)
            )}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('modal.statementResponsibility.labelTerms.2')}
          </a>
        </S.Text>
      )
    },
    {
      description: PRIVACY_POLICY,
      label: (
        <S.Text>
          {t('modal.statementResponsibility.labelTerms.1')}
          {t('modal.statementResponsibility.labelTerms.1_2')}
          <a
            href={TermsAPI.getTermDocument(
              'politica-de-privacidade',
              getVersion(PRIVACY_POLICY)
            )}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('modal.statementResponsibility.labelTerms.3')}
          </a>
        </S.Text>
      )
    }
  ];

  const filterItens = () => {
    filtredItems = fetchedTerms
      .map(item => {
        let localItem = item;
        const newItem = ALL_TERMS.find(
          e => e.description === localItem.description
        );

        if (newItem) {
          localItem = {
            ...localItem,
            label: newItem.label
          };
        }

        return localItem;
      })
      .filter(e => e.label);
  };

  const handlerCheck = isChecked => {
    if (isChecked) {
      setQtdTerms(qtdAcceptedTerms + 1);
    } else {
      setQtdTerms(qtdAcceptedTerms - 1);
    }
  };

  const setAcceptanceTerm = async termID => {
    const { userId } = Cookies.getJSON(USER_ACCESS_COOKIE);
    const { username } = Cookies.getJSON(USER_ACCESS_COOKIE);
    try {
      await TermsAPI.setAcceptanceTerm(termID, userId, username);

      return true;
    } catch (error) {
      return false;
    }
  };

  const handlerClick = async () => {
    const myPromisses = [];
    setIsLoading(true);
    filtredItems.forEach(item => {
      myPromisses.push(setAcceptanceTerm(item.id));
    });

    Promise.all(myPromisses).then(arrayResponse => {
      if (arrayResponse.indexOf(false) >= 0) {
        setModalStatus({ open: true, type: 'statementResponsibilityError' });
      } else {
        toggleModal('statementResponsibility');
      }
      setIsLoading(false);
    });
  };

  filterItens();

  return (
    <S.Container className="container-check-terms">
      <S.Title>{t('modal.statementResponsibility.title')}</S.Title>

      {t('modal.statementResponsibility.text')}

      {filtredItems.map(e => (
        <Check label={e.label} handlerCheck={handlerCheck} />
      ))}

      <S.ActionButton
        data-testid="btn-accept-term"
        variant="primary"
        size="big"
        disabled={qtdAcceptedTerms !== filtredItems.length}
        onClick={handlerClick}
        isLoading={isLoading}
      >
        {t('modal.statementResponsibility.button')}
      </S.ActionButton>
    </S.Container>
  );
};

Terms.propTypes = {
  toggleModal: PropTypes.func,
  setModalStatus: PropTypes.func,
  fetchedTerms: PropTypes.instanceOf(Array)
};
